<template>
    <div class="member">
        <section class="member-login">
            <div class="member-login-image">
                <a href="/">
                    <img :src="`/images/logo-${theme}.png`" alt="app-logo" />
                </a>
            </div>
            <div v-if="!!loginMain"
                 class="member-login-menu"
            >
                <h1>
                    {{ $t('members.login.welcome_text') }}
                </h1>
                <p>{{ $t('members.login.welcome_description') }}</p>
                <div class="member-login-wrapper">
                    <a :href="`${crmDomain}/login`">
                        {{ $t('members.login.organization') }}
                    </a>
                    <a href="#"
                       @click.prevent="toggleForm"
                    >
                        {{ $t('members.login.member') }}
                    </a>
                </div>
                <a href="/">
                    {{ $t('members.login.back_to_main') }}
                </a>
            </div>
            <div v-else
                 class="member-login-menu"
            >
                <h1>
                    {{ $t('members.login.welcome_text') }}
                </h1>
                <p>{{ $t('members.login.get_your_membership_details') }}</p>
                <div class="member-login-wrapper">
                    <form @submit.prevent="onMemberLoginEvent">
                        <form-group :label="$t('members.login.username')"
                                    :errors="modelErrors"
                                    name="username"
                        >
                            <input :value="model.username"
                                   :placeholder="$t('members.login.enter_username')"
                                   :disabled="isLoading"
                                   type="text"
                                   name="username"
                                   @input="updateModelField('username', $event.target.value)"
                            />
                        </form-group>
                        <form-group :label="$t('members.login.password')"
                                    :errors="modelErrors"
                                    name="password"
                        >
                            <input :value="model.password"
                                   :placeholder="$t('members.login.enter_password')"
                                   :disabled="isLoading"
                                   type="password"
                                   name="password"
                                   @input="updateModelField('password', $event.target.value)"
                            />
                        </form-group>
                        <button type="submit"
                                :disabled="isLoading"
                        >
                            <span v-if="!isLoading">{{ $t('members.home.login') }}</span>
                            <button-loader v-else />
                        </button>
                    </form>
                </div>
                <a href="#"
                   @click.prevent="toggleForm"
                >
                    {{ $t('members.login.back_to_login') }}
                </a>
            </div>
        </section>
    </div>
</template>

<script>
import MembersViewModel from '../MembersViewModel';
import PageLoader from '../../../../Custom/Shared/PageLoader/PageLoader';
import { parse } from '../../../../Src/Utils/Json';
import FormGroup from '../../../Components/Forms/Holders/FormGroup';
import ButtonLoader from '../../../Components/Loader/ButtonLoader';
import HandlesResponse from '../../../Concerns/HandlesResponse';

export default {
    name: 'MemberLogin',
    mixins: [
        MembersViewModel,
        HandlesResponse,
    ],
    components: {
        ButtonLoader,
        FormGroup
    },
    data() {
        return {
            loginMain: true,
            isLoading: false,
            model: {
                username: null,
                password: null,
            },
            modelErrors: {},
        };
    },
    methods: {
        async onMemberLoginEvent() {
            this.isLoading = true;

            try {
                const response = await window.axios.post('/members/login', this.model);

                const { status, message, data: { redirect } } = response.data;

                if (status) {
                    window.location.href = redirect;
                }

                this.$toastResponse(message, status);

                this.isLoading = false;
            } catch (error) {
                this.modelErrors = this.getResponseErrors(error);

                this.isLoading = false;
            }
        },
        updateModelField(name, value) {
            Object.assign(this.model, {
                [name]: value,
            });
        },
        setLoginMain() {
            const opened = this.$router.queryParam('o');

            if (opened === null) {
                return;
            }

            this.loginMain = parse(opened);
        },
        toggleForm() {
            this.loginMain = !this.loginMain;

            const url = !this.loginMain
                ? `?o=false`
                : ``;

            window.history.pushState({}, null, `/members/login${url}`);
        },
    },
    created() {
        this.setLoginMain();
    },
    mounted() {
        PageLoader.removeLoader();
    },
}
</script>